import { useCallback } from 'react';

import { useQueryParamValue } from '#src/app/shared/hooks/location';
import type { UseShareActionsOptions } from '#src/app/shared/hooks/share';

export function useGetShareTrackingData(): UseShareActionsOptions['getTrackingData'] {
	const sourceLocation = useQueryParamValue('source_location');

	return useCallback(
		(channel) => ({
			location: channel,
			view_context: 'petition_guides_article',
			source_location: sourceLocation,
		}),
		[sourceLocation],
	);
}
